module.exports = __webpack_public_path__ + "static/media/golfer-3-a.84e9ce1b.png";